import * as firebase from "../firebase";

export default {
  methods: {
    uploadFile: function(file, onSuccess, toast = true) {
      let storageRef = firebase.storage.ref(file.name);
      storageRef
        .put(file)
        .then(snapshot => {
          if (toast)
            this.$toast.open({ message: "Uploaded file!", duration: 2000 });
          snapshot.ref.getDownloadURL().then(url => {
            onSuccess(url);
          });
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    }
  }
};
